import * as React from 'react';
import { CampaignNodes } from 'types/ts/campaigns.ts';
import { Grid, Modal, Header } from 'semantic-grab-ui/src';
import {
  getScenarioConstraints,
  getCountConditionConstraints,
  getTimeConstraints,
  getDelayConstraints,
} from 'components/form/trident-campaigns/constraints';

export const getModal = (
  title: string,
  WidgetForm: React.ElementType,
  widgetFormProps,
) => {
  return (
    <Modal size="small" open>
      <Modal.Header>
        <Grid columns="equal">
          <Grid.Column>
            <Header as="h2">{title}</Header>
          </Grid.Column>
        </Grid>
      </Modal.Header>
      <Modal.Content scrolling>
        <WidgetForm {...widgetFormProps} />
      </Modal.Content>
    </Modal>
  );
};

export const GET_CONSTRAINTS_FUNCTION = {
  scenarios: getScenarioConstraints,
  time: getTimeConstraints,
  countCondition: getCountConditionConstraints,
  delay: getDelayConstraints,
};

export const MODAL_TYPE = {
  actions: 'action',
  scenarios: 'scenario',
  count: 'counter',
  time: 'timeTrigger',
  condition: 'condition',
  countCondition: 'countCondition',
  delay: 'delay',
  experiment: 'experiment',
  randomizer: 'randomizer',
};

export const INITIAL_NODE = {
  scenarios: {
    type: 'scenarios',
    data: {
      scenarios: [{}],
    },
  },
  time: {
    type: 'time',
    data: {
      frequency: 'nr',
    },
  },
  condition: {
    type: 'condition',
    data: {},
  },
  count: {
    type: 'count',
    data: {},
  },
  countCondition: {
    type: 'countCondition',
    data: {},
  },
  actions: {
    type: 'actions',
    data: [],
  },
  delay: {
    type: 'delay',
    data: {},
  },
  randomizer: {
    type: 'randomizer',
    data: {},
  },
  experiment: {
    type: 'experiment',
    data: {},
  },
  experimentTreatment: {
    type: 'experimentTreatment',
    data: {
      groupPercentage: [],
    },
  },
};

export const spanOn = (curr: number, parsed: CampaignNodes) => {
  if (!parsed[curr]) {
    return 0;
  }
  if (!parsed[curr].children) {
    return 1;
  }
  return parsed[curr].children.reduce((currentValue, id) => {
    return currentValue + parseInt(spanOn(Number(id), parsed), 10);
  }, 0);
};

export const flatten = (
  nodes: CampaignNodes,
  curr: string,
  currArr: number[],
  mainArr: number[][],
) => {
  if (!nodes) {
    return;
  }
  if (!(nodes[curr] && nodes[curr].children)) {
    mainArr.push(currArr);
    return;
  }

  for (let i = 0; i < nodes[curr].children.length; i += 1) {
    let newArr = currArr;
    if (i > 0) {
      newArr = currArr.map(item => {
        return item > 0 ? -1 * item : item;
      });
    }
    newArr = newArr.concat(parseInt(nodes[curr].children[i], 10));
    flatten(nodes, nodes[curr].children[i], newArr, mainArr);
  }
  return mainArr;
};

export const JOURNEY_CAMPAIGN_TYPE = 'journey';
